import { IFeeTable } from '../ITaxesTable';
import { VatCalculatingError } from '../Errors/VatCalculatingError';
import { CacheKeys } from '../../../../cache/cacheKeys';
import { ITaxLoader } from '../TaxLoader/ITaxLoader';
import { TaxLoaderError } from '../Errors/TaxLoaderError';
import { ITaxes } from '../iTaxes';
import { FeeCalculatingError } from '../Errors/FeeCalculatingError';
import { CacheRepository } from '../../../../cache/iCacheRepository';

export class FeeService implements ITaxes {
    private feeTable: IFeeTable;
    private storage: CacheRepository;
    private taxLoader: ITaxLoader;

    constructor(storage: CacheRepository, taxLoader: ITaxLoader) {
        this.storage = storage;
        this.taxLoader = taxLoader;
    }

    public async calculate(revenue: number, paymentMethod: string, vat: number): Promise<number> {
        try {
            const table = await this.load();
            if (table instanceof VatCalculatingError) {
                window.Sentry.captureException(table.message);
                return 0;
            }

            if (!paymentMethod) {
                console.error(`FEE payment method is false ${paymentMethod}`);
                return 0;
            }

            if (!table.fee_rate[paymentMethod]) {
                console.error('Payment method is not exists in a map', {
                    method: paymentMethod
                });
                return 0;
            }

            console.log('FEE calculating', {
                feeTable: table.fee_rate[paymentMethod],
                revenue: revenue,
                vat: vat
            });
            return (revenue - vat) * (1 - table.fee_rate[paymentMethod]);
        } catch (exception) {
            window.Sentry.captureException(exception);
            console.error('FEE exception on calculate', exception);
            return 0;
        }
    }

    private async load(): Promise<IFeeTable | VatCalculatingError> {
        const feeTable: IFeeTable = this.storage.get<IFeeTable>(CacheKeys.FEE);
        if (feeTable && feeTable.fee_rate && this.isValidDate(feeTable.date)) {
            console.log('FEE has loaded from storage');
            return feeTable;
        }

        if (this.feeTable && this.isValidDate(this.feeTable.date)) {
            console.log('FEE has loaded from memory');
            return this.feeTable;
        }

        const actualFeeTable = await this.taxLoader.getFee();
        if (actualFeeTable instanceof TaxLoaderError) {
            return new FeeCalculatingError(actualFeeTable.message);
        }
        console.log('FEE has loaded from DE', actualFeeTable);

        this.save(actualFeeTable);

        return actualFeeTable;
    }

    private save(table: IFeeTable): boolean | VatCalculatingError {
        try {
            table.date = this.getCurrentDateISO();
            this.feeTable = table;
            this.storage.delete(CacheKeys.FEE);
            this.storage.set(CacheKeys.FEE, this.feeTable);
            return true;
        } catch (exception) {
            return new FeeCalculatingError(
                exception.message,
                exception.stack
            );
        }
    }

    private getCurrentDateISO(): string {
        const date = new Date();
        return date.toISOString().split('T')[0];
    }

    private isValidDate(date: string): boolean {
        const secInDay = 86400;
        const daysOffset = 7;

        const tableTimestampSec = new Date(date).getTime() / 1000;
        const currentTimestampSec = new Date().getTime() / 1000;
        console.log('Fee data actuality', {
            forUpdate: currentTimestampSec,
            result: tableTimestampSec < currentTimestampSec - daysOffset * secInDay,
            table: tableTimestampSec
        });

        return tableTimestampSec > currentTimestampSec - daysOffset * secInDay;
    }
}
